import React from 'react';

const Logout = () => (
    <p>Logout not yet implemented</p>
);

export default Logout;
